import React from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { useInteractMedia } from 'Hooks/Document';
import { DocumentFieldTypes } from 'Interfaces/DocumentFields';
import { capitalize } from 'lodash';

import { fieldShapesByType } from '../common/fieldShapes';

import RemoveFieldButton from './RemoveFieldButton';

interface InteractSelectItemTitleProps {
  fieldType: DocumentFieldTypes;
  showRemoveFieldButton?: boolean;
  onRemoveField: () => void;
}

const InteractSelectItemTitle = ({
  fieldType,
  showRemoveFieldButton,
  onRemoveField,
}: InteractSelectItemTitleProps) => {
  const fieldShape = fieldShapesByType[fieldType];
  const { icon, type, iconType } = fieldShape;

  const [isMobile] = useInteractMedia(['sm']);

  return (
    <div
      className={classNames('interactModal__fieldBar-selectField-item', {
        'interactModal__fieldBar-selectField-item--stroke': iconType === 'stroke',
        'interactModal__fieldBar-selectField-item--fill': iconType === 'fill',
      })}
    >
      <div className="interactModal__fieldBar-selectField-item-inner">
        <ReactSVG src={icon} className="interactModal__fieldBar-selectField-item-icon" />
        <p className="interactModal__fieldBar-selectField-item-label">
          {capitalize(type)}
        </p>
      </div>
      {showRemoveFieldButton && (
        <RemoveFieldButton
          onClick={onRemoveField}
          variant={isMobile ? 'filled' : 'icon'}
        />
      )}
    </div>
  );
};

export default InteractSelectItemTitle;
